export * from './addressBook.service';
import { AddressBookService } from './addressBook.service';
export * from './addressBookContact.service';
import { AddressBookContactService } from './addressBookContact.service';
export * from './addressBookMapping.service';
import { AddressBookMappingService } from './addressBookMapping.service';
export const APIS = [AddressBookService, AddressBookContactService, AddressBookMappingService];
